import React, { Component } from "react";
import KnoaTab from "../Common/KnoaTab";
import {Row, Col, FormGroup} from "react-bootstrap";

class ProjectReports extends Component {
  render() {
    const {projects, handleProjectReportsUpdate, selectAllHandler,isSelectAllChecked,resetSelectAllCheckStatus,
      reportType, trans} = this.props;
    return (
      <FormGroup>
        <Row>
          <Col className="ps-5">
            <h4 className={"knoa-region mt-1"} tabIndex={"-1"}>{trans('project:selectReports')}</h4>
            <KnoaTab
              data={projects}
              controlId="formReports"
              handleProjectReportsUpdate={handleProjectReportsUpdate}
              selectAllHandler={selectAllHandler}
              isSelectAllChecked ={isSelectAllChecked}
              resetSelectAllCheckStatus={resetSelectAllCheckStatus}
              reportType={reportType}
              trans={trans}
            />
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

export default ProjectReports;